import styles from "./styles/dots.module.css";

const Dots = () => {
  return (
    <>
      <div className={styles.dots}>
        <div className={styles.dot}></div>
        <div className={styles.dot}></div>
        <div className={styles.dot}></div>
      </div>
    </>
  );
};

export default Dots;
